import { render, staticRenderFns } from "./whatsapp.component.vue?vue&type=template&id=34ed48a4&scoped=true"
import script from "./whatsapp.component.vue?vue&type=script&lang=js"
export * from "./whatsapp.component.vue?vue&type=script&lang=js"
import style0 from "./whatsapp.component.vue?vue&type=style&index=0&id=34ed48a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ed48a4",
  null
  
)

export default component.exports